import { Injectable, Injector } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable, from, throwError } from "rxjs";
import { catchError, mergeMap } from "rxjs/operators";
import { AuthService } from "../auth/auth.service";
import { ErrorService } from "../error/error.service";
import { ILogin } from "../../model/top.model";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (error.error === "expired token") {
          console.log("expired token");
          const authService = this.injector.get(AuthService);
          return from(authService.getAuthorizationLogin()).pipe(
            mergeMap((login: ILogin) => {
              return authService.login(null, null, login.refresh_token).pipe(
                mergeMap((newLogin) => {
                  authService.setAuthorizationLogin(newLogin);
                  const authReq = request.clone({
                    headers: request.headers.set(
                      "Authorization",
                      `${newLogin.token}`
                    ),
                  });
                  console.log("handle authReq");
                  return next.handle(authReq);
                })
              );
            })
          );
        } else {
          const errorService = this.injector.get(ErrorService);
          errorService.handleError(error);
          return throwError(error);
        }
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/http-interceptors/error-interceptor.ts